<template>
  <div id="event-live-eventer-message-form">
    <div class="event-live-eventer-message-form--section--form">
      <img v-bind:src="image" class="event-live-eventer-message-form--image__circle">
      <textarea name="body" class="event-live-eventer-message--input" maxlength="1000" :rows="setTextareaRows(inputForm)" v-bind:placeholder="eventerMessagePlaceholder" v-model="inputForm"></textarea>
      <div class="event-live-eventer-message--section--wrap--button__gray">
        <button v-on:click="speak" v-bind:disabled="inputForm == '' || 1 > inputForm.trim().length"  class="event-live-eventer-message--button__gray">コメント投稿</button>
      </div>
    </div>
    <div class="event-live-eventer-message-list--line__gray"></div>
  </div>
</template>

<script>
  import {db} from '../utils/firebase'
  import firebase from "firebase/app"
  import consts from '../utils/consts'

  export default {
    name: "EventLiveEventerMessageForm",
    props: {
      ttsid: { type: String, required: true },
      uimage: { type: String, required: true },
      uname: { type: String, required: true },
      uid: { type: String, required: true },
    },
    data: () => ({
      inputForm: "",
      image: ""
    }),
    firestore() {
      const roomId = this.ttsid;
      const firstdoc = "start";
      (async () => {
        // roomの存在チェック
        const postRefParent = db.collection(consts.EVENT_LIVE_EVENTER_COMMENT.PARENT_COLLECTION).doc(roomId)
        const postDocParent = await postRefParent.get()
        if (!postDocParent.exists) {
          // room生成
          await postRefParent.set({roomID: roomId},{merge: true})
        }
      })()
    },
    computed: {
      consts: function() {
        return consts
      },
      eventerMessagePlaceholder() {
        return this.uname + 'としてコメントを入力します'
      },
    },
    methods: {
      // コメント投稿
      speak: function(event){
        var body = this.inputForm
        if (1 > body.trim().length) {
          alert("1文字以上入力してください。")
          return;
        } else if (body.trim().length > 1000) {
          alert("1000文字以下で入力してください。")
          return;
        } else {
          db.collection(consts.EVENT_LIVE_EVENTER_COMMENT.PARENT_COLLECTION).doc(this.ttsid).collection(consts.EVENT_LIVE_EVENTER_COMMENT.CHILD_COLLECTTION).add({
            body: body,
            uId: this.uid,
            uName:this.uname,
            avatar: this.uimage,
            do_edit: false,
            is_fix_top: false,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          })
          this.inputForm = ""
        }
        event.preventDefault()
      },
      setTextareaRows: function(body) {
        var rows = (body.match( /\n/g ) || [] ).length + 1
        if (1 > rows){
          rows = 1
        }
        return rows
      },
    },
    watch: {
    },
    created(){
    },
    mounted: function () {
      // 投稿者名の設定
      var _name = "関係者";
      if (1 > this.uname.length) {
        this.uname = _name
      }
      // 画像の設定
      if (this.uimage) {
        this.image = this.uimage
      } else {
        this.image = require('assets/images/person_shadow_gray')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../packs/application.css';

  .event-live-eventer-message-form--section--form {
    margin-bottom: 25px;
    display: flex;

    @media screen and (max-width: 400px) {
      display: inline;
    }
  }

  .event-live-eventer-message-form--image__circle {
    border-radius: 50%;
    width: 50px;
    height: 50px;
    margin-right: 10px;
    margin-top: -5px;

    @media screen and (max-width: 400px) {
      margin-top: -35px;
    }
  }

  .event-live-eventer-message--input {
    width: 100%;
    height: 40px;
    padding:10px 7px;
    background: #FAFAFA;
    border: 1px solid #DCDCDC;
    resize: vertical;

    @media screen and (max-width: 1000px) {
      font-size: 16px;
    }

    @media screen and (max-width: 400px) {
      width: calc(100% - 70px);
    }
  }

  .event-live-eventer-message--input::placeholder {

    @media screen and (max-width: 1000px) {
      font-size: 14px;
      padding:0 ;
    }
  }

  .event-live-eventer-message--button__gray {
    height: 40px;
    width: 104px;
    background-color: #666666;
    color: #FFFFFF;
    border: none;
    margin-left: 10px;
    white-space: nowrap;

    @media screen and (max-width: 400px) {
      margin-right: 5px;
      margin-top: 4px;
    }
  }

  .event-live-eventer-message--button__gray:disabled {
    opacity: 0.5;
  }

  .event-live-eventer-message--section--wrap--button__gray {

    @media screen and (max-width: 400px) {
      text-align: right;
    }
  }

  .event-live-eventer-message-list--line__gray {
    border-bottom: 1px solid #B3B4B3;
    height: 1px;
    margin-right: 5px;
    width: 100%;
    margin-bottom: 25px;

    @media screen and (max-width: 1000px) {
      width: 100vw;
      margin: 12px 0 25px -20px;
    }
  }

</style>
